<p-toast></p-toast>

<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>


<div class="card">

    <!-- GO BACK -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>


    <p-table #dt [value]="stores" responsive="true" [rows]="30" paginator="true"
        [globalFilterFields]="['countryId','area','currCode','descrip','offLang']" [columns]="
                   [{ field: 'countryId', header: '{{translations.lbl_id}}' },
                    { field: 'area', header: '{{translations.lbl_name}}' },
                    { field: 'currCode', header: '{{translations.lbl_area_code}}' },
                    { field: 'descrip', header: '{{translations.lbl_language}}' },
                    { field: 'offLang', header: '{{translations.lbl_currency}}' }]"
                    currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
                    [showCurrentPageReport]="true">
        <!-- CAPTION -->
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-left p-jc-between">
                <!-- MAIN TITLE-->
                <h5 class="p-md-6">{{translations.lbl_zone_price_list}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </span>
            </div>
        </ng-template>


        <ng-template pTemplate="header">
            <!-- Order -->
            <tr>
                <th pSortableColumn="countryId">{{translations.lbl_id}}<p-sortIcon field="countryId"></p-sortIcon></th>
                <th pSortableColumn="area">{{translations.lbl_name}}<p-sortIcon field="area"></p-sortIcon></th>
                <th pSortableColumn="currCode">{{translations.lbl_area_code}}<p-sortIcon field="currCode"></p-sortIcon></th>
                <th pSortableColumn="descrip">{{translations.lbl_language}}<p-sortIcon field="descrip"></p-sortIcon></th>
                <th pSortableColumn="offLang">{{translations.lbl_currency}}<p-sortIcon field="offLang"></p-sortIcon></th>
                <th>{{translations.lbl_select}}</th>
            </tr>
            <!-- Filter -->
            <tr>
                <th>
                    <p-columnFilter type="text" field="countryId"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="area"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="currCode"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="descrip"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="offLang"></p-columnFilter>
                </th>
                <th></th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item?.countryId ?item.countryId : 'S/N' }}</td>
                <td>{{ item?.descrip ?item.descrip : 'S/N'}}</td>
                <td>{{ item?.area ?item.area : 'S/N'}}</td>
                <td>{{ item?.offLang ?item.offLang : 'S/N'}}</td>
                <td>{{ item?.currCode ?item.currCode : 'S/N'}}</td>
                <td>
                    <button pButton pRipple icon="pi pi-search" class="p-button-rounded p-mr-2"
                        (click)="redirectToPriceListByCountry(item)"></button>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{stores ? stores.length : 0 }} {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>

</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>